import React from "react";
import { IGameTableType } from "@/types/GlobalTypes";
import SlBet from "../../SlBet";

import "./index.scss";
import Nnary from "@/modules/Nnary";
import nary from "@/modules/nary";
import { assetImg } from "@/modules/moduleImporter";

export default class M33 extends React.Component<IGameTableType> {
    render() {
        const betLines = [
            ["A", "2", "3", "4", "5"],
            ["6", "7", "8", "9", "0"],
            ["J", "Q", "K"],
        ];

        const labels = [
            ["A", "2", "3", "4", "5"],
            ["6", "7", "8", "9", "10"],
            ["J", "Q", "K"].map(card =>
                assetImg("gb_history", card)    
            ),
        ];

        // const betTypes = [
        //     [...nary(5).map(_n => "1:2")],
        //     [...nary(5).map(_n => "1:2")],
        //     [...nary(3).map(_n => "1:3")]
        // ];
        const betTypes = [
            [...nary(5).map(_n => "1:1.5")],
            [...nary(5).map(_n => "1:1.5")],
            [...nary(3).map(_n => "1:6")]
        ];

        const lineClassList = [
            "top",
            "middle",
            "bottom"
        ];

        //Checks win prop
        const { win } = this.props;

        const winSplit = win ? win.split(",") : null;

        let wins: any[];
        const cardCounts = {};
        let anyDouble = false, anyTriple = false;

        if (winSplit) {
            wins = [
                nary(5),
                [...Nnary(6, 9), 0],
                ["J", "Q", "K"]
            ].map((row: any[]) => 
                row.map(cell =>
                    winSplit.indexOf(cell + "") >= 0
                )
            );

            // console.log("winSplit", wins);

            winSplit.forEach(num => {
                if (!cardCounts[num])
                    cardCounts[num] = 0;

                cardCounts[num]++;
            });

            Object.keys(cardCounts).forEach(num => {
                if (cardCounts[num] === 2)
                    anyDouble = true;

                if (cardCounts[num] === 3)
                    anyTriple = true;
            });
        }
        
		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
            insertBet: this.props.insertBet,
            langStr: this.props.langdata.language_code
		};

        return (
            <div className="sl-table m33">
                <div className="message">
                { this.props.langdata["txt_gbj_result_message"] }
                </div>

                {
                    betLines.map((line, rowIdx) =>
                        <div className={lineClassList[rowIdx]}
                            key={"m33_g_" + rowIdx}>
                        {
                            line.map((letter, cellIdx) => 
                                <SlBet key={"m33_" + line + "_" + cellIdx}

                                    classes="sl-bet sl-green-old"
                                    bet={letter}
                                    group="e1"

                                    winStatement={win && wins[rowIdx][cellIdx]}

                                    betLabel={labels[rowIdx][cellIdx]}
                                    betType={betTypes[rowIdx][cellIdx]}

                                    noTooltip={true}

                                    {...commonBetProps}
                                />
                            )
                        }
                        </div>
                    )
                }

                <div className="fifty-fifty">
                    <SlBet
                        classes="sl-bet col-xs-6 sl-green-new"
                        bet="double"
                        group="double"

                        winStatement={win && anyDouble}

                        betLabel={this.props.langdata["txt_any_double"]}
                        betType="1:4.5"

                        noTooltip={true}

                        {...commonBetProps}
                    />

                    <SlBet
                        classes="sl-bet col-xs-6 sl-cyan-new"
                        bet="triple"
                        group="triple"

                        winStatement={win && anyTriple}

                        betLabel={this.props.langdata["txt_any_triple"]}
                        betType="1:139"

                        noTooltip={true}

                        {...commonBetProps}
                    />
                </div>
            </div>
        );
    }
}